import React, { Component } from 'react';
import { Card } from 'antd';
import { inject } from 'mobx-react/index';
import { withRouter } from 'react-router-dom';
import { GeneralForm } from './GeneralForm';

@withRouter
@inject('store')
export class GeneralSection extends Component {
    render() {
        console.log('Update');
        return (
            <Card title={'General Settings'} bordered={false}>
                <GeneralForm data={this.props.store.botStore.currentConfiguration} />
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SettingsView/GeneralSection.js